import { useEffect, useState, useRef } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TurndownService from "turndown";
import ReactMarkdown from "react-markdown";
import { marked } from "marked";
import "./index.css";

const DOC_ID = "keDFszmagGke1PpHKMb1";
const turndownService = new TurndownService();

const modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const formats = ["bold", "italic", "underline", "list", "bullet"];

function BoasVindas() {
  const [dados, setDados] = useState(null);
  const [editando, setEditando] = useState(false);
  const [novo, setNovo] = useState({ markdown: "", banner: null });
  const [htmlContent, setHtmlContent] = useState("");
  const [bannerPreview, setBannerPreview] = useState(null);
  const fileRef = useRef(null);

  const fetchBoasVindas = async () => {
    try {
      const docRef = doc(db, "evento_boas_vindas", DOC_ID);
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        const markdown = data.texto || "";
        setDados({ markdown, banner: data.banner || null });
        setNovo({ markdown, banner: data.banner || null });
        setHtmlContent(marked(markdown));
        setBannerPreview(data.banner || null);
      }
    } catch (err) {
      console.error("Erro ao carregar:", err);
    }
  };

  useEffect(() => {
    fetchBoasVindas();
  }, []);

  const guardar = async () => {
    try {
      let bannerURL = bannerPreview;

      if (novo.banner && typeof novo.banner !== "string") {
        const bannerRef = ref(storage, `boasvindas/${novo.banner.name}`);
        await uploadBytes(bannerRef, novo.banner);
        bannerURL = await getDownloadURL(bannerRef);
      }

      const markdown = turndownService.turndown(htmlContent);

      const docRef = doc(db, "evento_boas_vindas", DOC_ID);
      await updateDoc(docRef, { texto: markdown, banner: bannerURL });

      setDados({ markdown, banner: bannerURL });
      setNovo({ markdown, banner: bannerURL });

      setHtmlContent(marked(markdown));
      setBannerPreview(bannerURL);
      setEditando(false);
      alert("Informação atualizada com sucesso!");
    } catch (err) {
      console.error(err);
      alert("Erro ao guardar.");
    }
  };

  if (!dados)
    return <p style={{ textAlign: "center", color: "#292f2c" }}>A carregar...</p>;

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Banner</th>
            <th>Texto</th>
            <th width="100px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {dados.banner ? (
                <img
                  src={dados.banner}
                  alt="Banner"
                  className="banner-noticia"
                />
              ) : "—"}
            </td>
            <td style={{ maxHeight: 600, overflow: "auto", fontSize: "0.9rem" }}>
              <ReactMarkdown>{dados.markdown}</ReactMarkdown>
            </td>
            <td>
              <button className="btn btn-add" onClick={() => {
                setEditando(true);
                setNovo(dados);
                setHtmlContent(marked(dados.markdown));
                setBannerPreview(dados.banner || null);
              }}>
                Editar
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {editando && (
        <div className="drawer">
          <div className="drawer-header">
          </div>

          <div className="drawer-content">
            <ReactQuill
              theme="snow"
              value={htmlContent}
              onChange={setHtmlContent}
              modules={modules}
              formats={formats}
              style={{ height: "445px", marginBottom: "50px" }}
            />

            <div>
              {bannerPreview && (
                <img src={bannerPreview} alt="Banner Preview" className="banner-noticia" 
                />
              )}
              <input
                type="file"
                ref={fileRef}
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setNovo(p => ({ ...p, banner: file }));
                  setBannerPreview(file ? URL.createObjectURL(file) : null);
                }}
              />
            </div>
          </div>

          <div className="drawer-footer">
            <button className="btn btn-add" onClick={guardar}>Guardar</button>
            <button className="btn btn-cancel" onClick={() => setEditando(false)}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default BoasVindas;
